import { extractDateFromFilename, formatCalendarDate } from "@ui/lib/date"
import type { ComponentType } from "react"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type MdxComponent = ComponentType<{ components?: Record<string, any> }>

interface MdxModule {
  default: MdxComponent
  frontmatter: Record<string, unknown>
}

export interface ContentEntry {
  slug: string
  date: string
  dateFormatted: string
  dateShort: string
  Content: MdxComponent
  frontmatter: Record<string, unknown>
}

function slugFromPath(path: string): string {
  const filename = path
    .split("/")
    .pop()!
    .replace(/\.(mdx?|md)$/, "")
  return filename.replace(/^\d{4}-\d{2}-\d{2}-/, "")
}

function dateFromPath(path: string): string {
  const filename = path.split("/").pop()!
  return extractDateFromFilename(filename)
}

export function resolveContent(modules: Record<string, MdxModule>): ContentEntry[] {
  return Object.entries(modules)
    .sort(([a], [b]) => b.localeCompare(a))
    .map(([path, mod]) => {
      const date = dateFromPath(path)
      return {
        slug: slugFromPath(path),
        date,
        dateFormatted: formatCalendarDate(date, "longDateGB"),
        dateShort: formatCalendarDate(date, "dateGB"),
        Content: mod.default,
        frontmatter: mod.frontmatter,
      }
    })
}
